var React = require('react');

function Oval (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd"},React.createElement("g",{"transform":"translate(1 1)","strokeWidth":"2"},[React.createElement("circle",{"strokeOpacity":".5","cx":"18","cy":"18","r":"18","key":0}),React.createElement("path",{"d":"M36 18c0-9.94-8.06-18-18-18","key":1},React.createElement("animateTransform",{"attributeName":"transform","type":"rotate","from":"0 18 18","to":"360 18 18","dur":"1s","repeatCount":"indefinite"}))])));
}

Oval.defaultProps = {"width":"38","height":"38","viewBox":"0 0 38 38","stroke":"#fff"};

module.exports = Oval;

Oval.default = Oval;
